module.exports = __webpack_public_path__ + "img/color_block_3.2921b915.svg";